(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mira-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mira-hero-gallery')) {
    customElements.define('mira-hero-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        const track = this.querySelector('.mira-hero__track');
        const slides = Array.from(this.querySelectorAll('.mira-hero__slide'));
        const previous = this.querySelector('.mira-hero__previous');
        const next = this.querySelector('.mira-hero__next');
        if (!track || slides.length < 2 || !previous || !next) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const counter = this.querySelector('.mira-hero__counter');
        const status = this.querySelector('.mira-hero__status');
        const autoplay = this.querySelector('.mira-hero__autoplay');
        const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const interval = Math.max(3000, Number(this.dataset.interval) || 5000);
        let paused = this.dataset.autoplay !== 'true' || motion.matches || Boolean(window.Shopify?.designMode);
        let hovered = false;
        let focused = false;
        let interacting = false;
        let index = 0;
        const stopTimer = () => window.clearTimeout(this.timer);
        const syncPlayback = () => {
          stopTimer();
          const running = !paused && !hovered && !focused && !interacting && !document.hidden;
          this.dataset.playing = String(!paused);
          if (autoplay) autoplay.setAttribute('aria-label', paused ? autoplay.dataset.playLabel : autoplay.dataset.pauseLabel);
          status.setAttribute('aria-live', running ? 'off' : 'polite');
          if (running) {
            this.timer = window.setTimeout(() => {
              const target = (index + 1) % slides.length;
              show(target, target === 0 ? 'instant' : undefined);
              syncPlayback();
            }, interval);
          }
        };
        const update = () => {
          if (!track.clientWidth) return;
          index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
          previous.disabled = index === 0;
          next.disabled = index === slides.length - 1;
          counter.textContent = `${index + 1} / ${slides.length}`;
          status.textContent = this.dataset.statusTemplate.replace('__current__', String(index + 1));
          slides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== index)));
        };
        const show = (value, behavior) => {
          const target = Math.max(0, Math.min(slides.length - 1, value));
          track.scrollTo({left: target * track.clientWidth, behavior});
        };
        const manualShow = value => {
          show(value);
          syncPlayback();
        };
        previous.addEventListener('click', () => manualShow(index - 1), {signal});
        next.addEventListener('click', () => manualShow(index + 1), {signal});
        track.addEventListener('scroll', update, {signal, passive: true});
        track.addEventListener('scrollend', syncPlayback, {signal});
        this.addEventListener('pointerenter', event => {
          if (event.pointerType === 'touch') return;
          hovered = true;
          syncPlayback();
        }, {signal});
        this.addEventListener('pointerleave', () => {
          hovered = false;
          syncPlayback();
        }, {signal});
        this.addEventListener('focusin', () => {
          focused = true;
          syncPlayback();
        }, {signal});
        this.addEventListener('focusout', event => {
          focused = this.contains(event.relatedTarget);
          syncPlayback();
        }, {signal});
        track.addEventListener('pointerdown', () => {
          interacting = true;
          syncPlayback();
        }, {signal});
        const endInteraction = () => {
          if (!interacting) return;
          interacting = false;
          syncPlayback();
        };
        window.addEventListener('pointerup', endInteraction, {signal});
        window.addEventListener('pointercancel', endInteraction, {signal});
        document.addEventListener('visibilitychange', syncPlayback, {signal});
        motion.addEventListener('change', () => {
          if (motion.matches) paused = true;
          syncPlayback();
        }, {signal});
        autoplay?.addEventListener('click', () => {
          paused = !paused;
          if (!paused) {
            focused = false;
            hovered = false;
          }
          syncPlayback();
        }, {signal});
        this.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            manualShow(index + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, {signal});
        this.addEventListener('shopify:block:select', event => {
          const selected = slides.indexOf(event.target.closest('.mira-hero__slide'));
          if (selected >= 0) {
            paused = true;
            manualShow(selected);
          }
        }, {signal});
        this.observer = new ResizeObserver(() => {
          track.scrollTo({left: index * track.clientWidth, behavior: 'instant'});
          update();
        });
        this.observer.observe(track);
        update();
        syncPlayback();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        window.clearTimeout(this.timer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mira-store-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mira-store-gallery')) {
    customElements.define('mira-store-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const gallery = this.querySelector('.mrg__gallery');
        const track = this.querySelector('.mrg__track');
        const slides = Array.from(this.querySelectorAll('.mrg__slide'));
        const previous = this.querySelector('.mrg__previous');
        const next = this.querySelector('.mrg__next');
        const counter = this.querySelector('.mrg__counter');
        const status = this.querySelector('.mrg__status');
        if (!gallery || slides.length < 2) return;
        let index = 0;
        let gesture = null;
        const showSlide = value => {
          index = Math.max(0, Math.min(slides.length - 1, value));
          track.style.transition = '';
          track.style.transform = `translateX(${-index * 100}%)`;
          previous.disabled = index === 0;
          next.disabled = index === slides.length - 1;
          counter.textContent = `${index + 1} / ${slides.length}`;
          status.textContent = this.dataset.statusTemplate.replace('__current__', String(index + 1));
          slides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== index)));
        };
        previous.addEventListener('click', () => showSlide(index - 1), { signal });
        next.addEventListener('click', () => showSlide(index + 1), { signal });
        gallery.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            showSlide(index + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, { signal });
        gallery.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0 || event.target.closest('button,a')) return;
          gesture = { id:event.pointerId, startX:event.clientX, startY:event.clientY, delta:0, horizontal:false };
          gallery.setPointerCapture(event.pointerId);
        }, { signal });
        gallery.addEventListener('pointermove', event => {
          if (!gesture || event.pointerId !== gesture.id) return;
          const dx = event.clientX - gesture.startX;
          const dy = event.clientY - gesture.startY;
          if (!gesture.horizontal && Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 10) {
            const id = gesture.id;
            gesture = null;
            gallery.releasePointerCapture(id);
            return;
          }
          if (!gesture.horizontal && Math.abs(dx) < 7) return;
          gesture.horizontal = true;
          gesture.delta = dx;
          gallery.classList.add('is-dragging');
          track.style.transition = 'none';
          const limited = (index === 0 && dx > 0) || (index === slides.length - 1 && dx < 0) ? dx * .18 : dx;
          track.style.transform = `translateX(calc(${-index * 100}% + ${limited}px))`;
        }, { signal });
        const endGesture = event => {
          if (!gesture || gesture.id !== event.pointerId) return;
          const current = gesture;
          gesture = null;
          gallery.classList.remove('is-dragging');
          if (gallery.hasPointerCapture(current.id)) gallery.releasePointerCapture(current.id);
          const threshold = Math.min(70, gallery.clientWidth * .15);
          const direction = event.type === 'pointerup' && current.horizontal && Math.abs(current.delta) > threshold ? (current.delta < 0 ? 1 : -1) : 0;
          showSlide(index + direction);
        };
        gallery.addEventListener('pointerup', endGesture, { signal });
        gallery.addEventListener('pointercancel', endGesture, { signal });
        gallery.addEventListener('lostpointercapture', endGesture, { signal });
        this.addEventListener('dragstart', event => event.preventDefault(), { signal });
        this.addEventListener('shopify:block:select', event => {
          const slide = event.target.closest('.mrg__slide');
          const selected = slides.indexOf(slide);
          if (selected >= 0) showSlide(selected);
        }, { signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
